module.exports = __webpack_public_path__ + "static/media/soc_mail.51464bf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_mail.svg
// module id = 389
// module chunks = 0